import LegacyDynamicPageRouter from "../LegacyDynamicPageRouter";

export default function Features() {
  /**
   * Importante:
   * - O legado renderizava a página atual via `usePages → CurrentPage`.
   * - A partir da refatoração, a seleção/guards/loading ficam centralizados
   *   no router dinâmico (`LegacyDynamicPageRouter`).
   * - Mantemos `Features` como "ponto de montagem" para reduzir impacto no resto.
   */
  return <LegacyDynamicPageRouter />;
}
